package com.tovtalk.ui.components

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.AllInclusive
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.VisibilityOff
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.ModalBottomSheet
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.unit.dp
import com.tovtalk.domain.entity.Post
import com.tovtalk.ui.theme.TovTalkTheme
import com.tovtalk.utils.strings.StringProvider

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ReelOptionsBottomSheet(
    post: Post,
    onDismiss: () -> Unit,
    onMakePermanent: () -> Unit,
    onDelete: () -> Unit,
    onNotInterested: (() -> Unit)? = null,
) {
    ModalBottomSheet(
        onDismissRequest = onDismiss,
        shape = TovTalkTheme.shapes.sheet,
        containerColor = TovTalkTheme.colors.surfaceElevated,
        contentColor = TovTalkTheme.colors.textPrimary,
        dragHandle = {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(vertical = TovTalkTheme.spacing.sm),
                contentAlignment = Alignment.Center
            ) {
                Surface(
                    modifier = Modifier
                        .width(TovTalkTheme.sizes.dragHandleWidth)
                        .height(TovTalkTheme.sizes.dragHandleHeight),
                    shape = TovTalkTheme.shapes.full,
                    color = TovTalkTheme.colors.textTertiary.copy(alpha = TovTalkTheme.opacity.medium)
                ) {}
            }
        }
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(bottom = TovTalkTheme.spacing.lg)
                .navigationBarsPadding()
        ) {
            if (post.isPermanent == false) {
                ReelOptionItem(
                    icon = Icons.Default.AllInclusive,
                    text = StringProvider.get("dialog_make_permanent_title"),
                    description = StringProvider.get("dialog_make_permanent_message"),
                    onClick = {
                        onMakePermanent()
                        onDismiss()
                    }
                )
            }
            ReelOptionItem(
                icon = Icons.Default.Delete,
                text = StringProvider.get("common_delete"),
                description = StringProvider.get("dialog_delete_reel_message"),
                onClick = {
                    onDelete()
                    onDismiss()
                },
                destructive = true
            )
            if (onNotInterested != null) {
                ReelOptionItem(
                    icon = Icons.Default.VisibilityOff,
                    text = StringProvider.get("reel_options_not_interested"),
                    description = StringProvider.get("reel_options_not_interested_description"),
                    onClick = {
                        onNotInterested()
                        onDismiss()
                    }
                )
            }
            HorizontalDivider(
                modifier = Modifier.padding(vertical = TovTalkTheme.spacing.sm),
                color = TovTalkTheme.colors.border,
                thickness = TovTalkTheme.sizes.dividerThickness
            )
            ReelOptionItem(
                icon = Icons.Default.Close,
                text = StringProvider.get("common_cancel"),
                description = null,
                onClick = onDismiss
            )
        }
    }
}

@Composable
private fun ReelOptionItem(
    icon: ImageVector,
    text: String,
    description: String? = null,
    onClick: () -> Unit,
    destructive: Boolean = false
) {
    val textColor = if (destructive) TovTalkTheme.colors.error else TovTalkTheme.colors.textPrimary
    val iconColor = if (destructive) TovTalkTheme.colors.error else TovTalkTheme.colors.textSecondary

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = TovTalkTheme.spacing.md, vertical = TovTalkTheme.spacing.sm),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Box(
                modifier = Modifier.size(TovTalkTheme.sizes.videoActionButton),
                contentAlignment = Alignment.Center
            ) {
                Icon(
                    imageVector = icon,
                    contentDescription = null,
                    tint = iconColor,
                    modifier = Modifier.size(TovTalkTheme.sizes.iconMd)
                )
            }
            Spacer(modifier = Modifier.width(TovTalkTheme.spacing.md))
            Column(modifier = Modifier.weight(1f)) {
                Text(
                    text = text,
                    style = TovTalkTheme.typography.bodyLarge,
                    color = textColor
                )
                if (description != null) {
                    Text(
                        text = description,
                        style = TovTalkTheme.typography.caption,
                        color = TovTalkTheme.colors.textTertiary
                    )
                }
            }
        }
    }
}
